<template lang="pug">
  Auth(@loggedIn="onLoggedIn"
    :redirectWithLoginFailed="true")
    div.wrap-payment
      ModulePayment(v-if="user" :user="user")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-payment {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import ModulePayment from '@/components/module/ModulePayment'

export default {
  components: {
    Auth, ModulePayment
  },
  data () {
    return {
      user: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    async onLoggedIn () {
      this.user = await database.userCollection().findById(this.uid)
    }
  }
}
</script>
